"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Error_1 = __importDefault(require("@mui/icons-material/Error"));
const Visibility_1 = __importDefault(require("@mui/icons-material/Visibility"));
const VisibilityOff_1 = __importDefault(require("@mui/icons-material/VisibilityOff"));
const material_1 = require("@mui/material");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const axios_1 = require("axios");
const pino_1 = __importDefault(require("pino"));
const react_1 = require("react");
const strings_1 = require("../../../../../constants/strings");
const uiConstants_1 = require("../../../../../constants/uiConstants");
const query_keys_1 = require("../../../../../queries/query-keys");
const sessionQuery_1 = require("../../../../../queries/sessionQuery");
const userRepository_1 = __importDefault(require("../../../../../repositories/userRepository"));
const Root_1 = require("../../../../../router/Root");
const routerUtils_1 = require("../../../../../router/routerUtils");
const userSelectors_1 = require("../../../../../selectors/userSelectors");
const zustandStore_1 = require("../../../../../zustandStore");
const simpleButton_1 = __importDefault(require("../../../../atoms/button/simpleButton"));
const styledBox_1 = require("../../common/styledBox");
const styledButtonLink_1 = require("../../common/styledButtonLink");
const styledText_1 = require("../../common/styledText");
const useValidation_1 = require("../../hsbc/hooks/useValidation");
const formInput_1 = __importDefault(require("../../hsbc/steps/common/formInput"));
const setupTwoFactorAuth_1 = require("../../hsbc/steps/defaultRegistration/step_4/setupTwoFactorAuth");
const useEmailInput_1 = require("../hooks/useEmailInput");
const usePasswordInput_1 = require("../hooks/usePasswordInput");
const EnterValidationCode = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./enterValidationCode'))));
const SetupTwoFactorAuth = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../../activateForm/setupTwoFactorAuth'))));
const VerifyPhoneSetupForm = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./verifyPhoneSetupForm'))));
const react_router_1 = require("react-router");
const AmexLoadingButton_1 = require("../../../../../material-ui-theme/components/styled/AmexLoadingButton");
const HsbcsLoadingButton_1 = require("../../../../../material-ui-theme/components/styled/HsbcsLoadingButton");
const sessionRepository_1 = require("../../../../../repositories/sessionRepository");
const routerUtils_2 = require("../../../../../router/routerUtils");
const setupTwoFactorAuth_2 = require("../../activateForm/setupTwoFactorAuth");
const logger = (0, pino_1.default)();
const lexico = new lexico_1.default();
const LoadingBtn = globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? HsbcsLoadingButton_1.HsbcLoadingButton : AmexLoadingButton_1.AmexLoadingButton;
const PasswordLogin = () => {
    const navigate = (0, react_router_1.useNavigate)();
    const location = (0, react_router_1.useLocation)();
    const [searchParams] = (0, react_router_1.useSearchParams)();
    const { redirectParams, inactivityLogoutMessage = '' } = location.state || {}; // Fallback in case state is undefined
    const inactivityLogoutParam = searchParams.get('inactivityLogout');
    const { email } = redirectParams || {};
    const { state: password, handlePasswordChange, handlePasswordValidation, clearPasswordState } = (0, usePasswordInput_1.usePasswordInput)();
    const { state: emailState, handleEmailChange, handleEmailValidation } = (0, useEmailInput_1.useEmailInput)(email);
    const { validateField, clearFieldError, fieldErrors } = (0, useValidation_1.useValidation)();
    const login = (0, sessionQuery_1.useLoginQuery)();
    const { navigateToLockedAccountMessage } = (0, routerUtils_1.useSigninMessageNavigation)();
    const { setLoginMethod, setNotification, setPageLoading, setStepsData, setIsFormLoading, setIsMfaAppSetupRequired, setIsMfaSmsSetupRequired, setIsPhoneSetupRequired, setIsMfaLoginRequired, setFormState, setShowTwoFactorAuth, setMfaData, passwordLogin, registration, } = (0, zustandStore_1.useZustand)(state => ({
        ...state,
    }));
    const theme = (0, material_1.useTheme)();
    const logout = (0, sessionQuery_1.useSessionLogoutQuery)();
    const [showPassword, setShowPassword] = (0, react_1.useState)(false);
    const [loginError, setLoginError] = (0, react_1.useState)('');
    const onLoginSuccess = async (data) => {
        try {
            if (globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP) {
                if (data?.passwordAttemptsExceeded) {
                    navigateToLockedAccountMessage('password');
                    return;
                }
                if (data?.mfaCodeAttemptsExceeded) {
                    navigateToLockedAccountMessage('password');
                    return;
                }
            }
            const user = await userRepository_1.default.getUser();
            Root_1.queryClient.setQueryData([query_keys_1.userKeys.getUser], user);
            const isTsAdmin = (0, userSelectors_1.isSupportAdmin)(user?.roles);
            if (user && !isTsAdmin && !(0, userSelectors_1.isCompanyOrSupportAdmin)(user?.roles) && user?.roles.length === 0) {
                setNotification([
                    {
                        type: strings_1.notificationStrings.ERROR,
                        message: lexico.trc('Error message', 'Your account has been disabled, please contact your company or team administrator.'),
                        onClose: () => {
                            logout.mutate();
                        },
                    },
                ]);
            }
            else if (isTsAdmin) {
                void navigate('/settings/overview');
            }
            else {
                const previousRoute = (0, routerUtils_2.getPreLoginRouterState)();
                if (previousRoute.redirectTo && !previousRoute.redirectTo.includes('signin')) {
                    void navigate(`${previousRoute.redirectTo}${previousRoute.redirectParams}`);
                    return;
                }
                const path = (0, userSelectors_1.isCompanyOrSupportAdmin)(user?.roles || []) ? '/wallet' : '/wallet/my-cards';
                globalThis.location.pathname = path;
            }
        }
        catch (error) {
            logger.error('error in onActivateUser:', error);
            setNotification([
                {
                    type: strings_1.notificationStrings.ERROR,
                    message: 'An error occurred while activating the user. Please try again.',
                },
            ]);
        }
    };
    const handleLoginError = (error) => {
        if (!(0, axios_1.isAxiosError)(error)) {
            setNotification([
                {
                    type: strings_1.notificationStrings.WARNING,
                    message: lexico.trc('Warning message', 'An error occurred, please try again later.'),
                },
            ]);
            return;
        }
        const errorStatus = error.response?.status;
        const errorCode = error.response?.data?.errorCode;
        if (globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP) {
            if (errorStatus === 403 && (errorCode === 'LOCKED_ACCOUNT' || !errorCode)) {
                logger.warn('Account locked due to multiple failed attempts', { errorCode });
                navigateToLockedAccountMessage('password');
                return;
            }
            if (errorStatus === 403 && errorCode === 'INCOMPLETE_ACTIVATION') {
                logger.warn('Account activation is incomplete', { errorCode });
                navigateToLockedAccountMessage('accountNotCreated');
                return;
            }
            if (errorStatus === 401) {
                setLoginError(lexico.tr("You've entered an invalid email or password, please try again"));
                return;
            }
        }
        if (errorStatus === 401) {
            setLoginError(lexico.trc('Warning message', 'Invalid email or password. Please check your credentials.'));
            return;
        }
        setNotification([
            {
                type: strings_1.notificationStrings.WARNING,
                message: lexico.trc('Warning message', 'An error occurred, please try again later.'),
            },
        ]);
    };
    const handleLoginSubmit = (event) => {
        event.preventDefault();
        if (!emailState.value) {
            return;
        }
        setIsFormLoading(true);
        setLoginError(''); // Clear previous error
        login.mutate({ username: String(emailState.value), password: password.passwordValue }, {
            onSuccess: async (data) => {
                setLoginError(''); // Clear error on success
                setNotification([]);
                setMfaData(data); // for Amex
                if (globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP) {
                    if (data.activationCodeAttemptsExceeded) {
                        navigateToLockedAccountMessage('activation');
                        return;
                    }
                    if (data.mfaCodeAttemptsExceeded) {
                        navigateToLockedAccountMessage('mfa');
                        return;
                    }
                }
                if (data?.mfaOtp?.status === 'setup_required') {
                    setShowTwoFactorAuth(true);
                }
                if (data?.mfaOtp) {
                    setStepsData({
                        mfaOtp: {
                            status: data.mfaOtp.status,
                            secret: data.mfaOtp.secret || '',
                            qrCode: data.mfaOtp.qrCode,
                        },
                    });
                }
                if (data?.mfaSms) {
                    setStepsData({
                        mfaSms: {
                            status: data.mfaSms.status,
                            phoneDetails: data.mfaSms.phoneDetails,
                        },
                    });
                }
                if (data?.phoneSetup) {
                    setStepsData({
                        phoneSetup: {
                            status: data.phoneSetup.status,
                            phoneDetails: data.phoneSetup.phoneDetails,
                        },
                    });
                }
                // the order here matters
                if (data?.mfaOtp?.status === 'setup_required') {
                    setIsMfaAppSetupRequired(true);
                }
                else if (data?.mfaSms?.status === 'login_required') {
                    setIsMfaSmsSetupRequired(true);
                }
                else if (data?.phoneSetup?.status === 'verification_needed') {
                    setIsPhoneSetupRequired(true);
                }
                else if (data?.mfaOtp?.status === 'login_required') {
                    setIsMfaLoginRequired(true);
                }
                else {
                    void onLoginSuccess(data);
                }
            },
            onError: (error) => {
                handleLoginError(error);
            },
            onSettled: () => {
                clearPasswordState();
                setIsFormLoading(false);
            },
        });
    };
    const handleLoginMfaInputChange = (e) => {
        const { name, value } = e.target;
        setFormState({ ...passwordLogin.formState, [name]: value });
        clearFieldError(name);
    };
    const handleLoginMfaInputBlur = (e) => {
        if (e) {
            const { name = '' } = e.target;
            validateField(setupTwoFactorAuth_1.twoFactorSchema, name, passwordLogin.formState);
        }
    };
    const handleLoginMfaSubmit = async (e) => {
        e.preventDefault();
        setPageLoading(true);
        try {
            await sessionRepository_1.SessionRepository.sendMfaCodeChallenge({
                code: passwordLogin.formState.authCode,
                challengeName: 'SOFTWARE_TOKEN_MFA',
            });
            return onLoginSuccess(undefined);
        }
        catch (error) {
            logger.error({ error });
            setNotification([
                {
                    type: strings_1.notificationStrings.ERROR,
                    message: setupTwoFactorAuth_2.invalidOtpCodeSentMessage,
                },
            ]);
        }
        finally {
            setPageLoading(false);
        }
    };
    if (passwordLogin.isMfaAppSetupRequired || registration.showTwoFactorAuth) {
        return ((0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)("div", {}), children: (0, jsx_runtime_1.jsx)(SetupTwoFactorAuth, { showNotificationMessage: !globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP }) }, location.state?.key));
    }
    else if (passwordLogin.isMfaSmsSetupRequired) {
        return ((0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)("div", {}), children: (0, jsx_runtime_1.jsx)(EnterValidationCode, { challengeName: "SMS_MFA" }) }, location.state?.key));
    }
    else if (passwordLogin.isPhoneSetupRequired) {
        return ((0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)("div", {}), children: (0, jsx_runtime_1.jsx)(VerifyPhoneSetupForm, {}) }, location.state?.key));
    }
    if (passwordLogin.isMfaLoginRequired) {
        return ((0, jsx_runtime_1.jsxs)("form", { "data-testid": "mfa-login-form", style: {
                padding: `0 ${theme.tsGoUnit.tsUnit} ${theme.tsGoUnit.tsUnit}`,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: theme.tsGoUnit.tsUnit,
            }, onSubmit: handleLoginMfaSubmit, children: [(0, jsx_runtime_1.jsx)(formInput_1.default, { label: "Authenticator app code", customInputLabelProps: { style: { fontWeight: theme.typography.tsFontWeight.default } }, name: "authCode", value: passwordLogin.formState.authCode, error: fieldErrors['authCode'], onChange: handleLoginMfaInputChange, onBlur: handleLoginMfaInputBlur, placeholder: "Enter a code from your authenticator app" }), (0, jsx_runtime_1.jsx)(LoadingBtn, { "data-testid": "login-code-button", style: { width: '100%', fontSize: theme.typography.pxToRem(theme.typography.tsFontSize.default) }, color: uiConstants_1.UI_BUTTON_PRIMARY, disabled: !setupTwoFactorAuth_1.twoFactorSchema.safeParse(passwordLogin.formState).success, type: "submit", loading: passwordLogin.isFormLoading, loadingPosition: "start", startIcon: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}), variant: "contained", children: lexico.tr('Send code') })] }));
    }
    return ((0, jsx_runtime_1.jsxs)("form", { "data-testid": "form", style: {
            padding: `0 ${theme.tsGoUnit.tsUnit} ${theme.tsGoUnit.tsUnit}`,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: theme.tsGoUnit.tsUnit,
        }, onSubmit: handleLoginSubmit, children: [globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP && (inactivityLogoutParam || inactivityLogoutMessage !== '') ? ((0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "subtitle1", sx: { mt: 0 }, children: inactivityLogoutParam
                    ? lexico.trc('Inactivity logout message', "You've been logged out due to inactivity, please login again")
                    : inactivityLogoutMessage })) : null, (0, jsx_runtime_1.jsxs)(material_1.FormControl, { style: { padding: 0 }, fullWidth: true, variant: "outlined", error: emailState.isError, children: [(0, jsx_runtime_1.jsx)(material_1.TextField, { label: lexico.tr('Email'), style: { padding: 0, margin: 0 }, type: "email", required: true, fullWidth: true, margin: "normal", variant: "outlined", autoComplete: "off", value: email || emailState.value, error: emailState.isError, onChange: e => handleEmailChange(e.target.value), onBlur: handleEmailValidation, slotProps: {
                            htmlInput: { 'data-testid': 'email' },
                            inputLabel: { style: { fontWeight: theme.typography.tsFontWeight.default } },
                        } }), emailState.isError && ((0, jsx_runtime_1.jsxs)(material_1.FormHelperText, { style: { marginLeft: 0 }, children: [(0, jsx_runtime_1.jsx)(Error_1.default, { fontSize: "small", style: { verticalAlign: 'middle' } }), " ", lexico.tr('Invalid email address')] }))] }), (0, jsx_runtime_1.jsxs)(material_1.FormControl, { style: { padding: 0 }, fullWidth: true, variant: "outlined", error: password.isPasswordError || !!loginError, children: [(0, jsx_runtime_1.jsx)(material_1.TextField, { name: "password", label: "Password", style: { padding: 0, margin: 0 }, type: showPassword ? 'text' : 'password', required: true, fullWidth: true, margin: "normal", variant: "outlined", autoComplete: "current-password", onChange: handlePasswordChange, onBlur: handlePasswordValidation, value: password.passwordValue, error: password.isPasswordError || !!loginError, slotProps: {
                            htmlInput: {
                                'data-testid': 'password',
                                autoComplete: 'current-password',
                            },
                            inputLabel: { style: { fontWeight: theme.typography.tsFontWeight.default } },
                            input: {
                                endAdornment: ((0, jsx_runtime_1.jsx)(material_1.InputAdornment, { position: "end", children: (0, jsx_runtime_1.jsx)(material_1.IconButton, { onClick: () => setShowPassword(prev => !prev), edge: "end", children: showPassword ? (0, jsx_runtime_1.jsx)(Visibility_1.default, { fontSize: "small" }) : (0, jsx_runtime_1.jsx)(VisibilityOff_1.default, { fontSize: "small" }) }) })),
                            },
                        } }), loginError && ((0, jsx_runtime_1.jsxs)(material_1.FormHelperText, { error: true, style: {
                            marginLeft: 0,
                            color: theme.palette.error.main,
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: '4px',
                        }, children: [(0, jsx_runtime_1.jsx)(Error_1.default, { fontSize: "small", style: { marginTop: '2px' } }), (0, jsx_runtime_1.jsx)("span", { children: loginError })] }))] }), (0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, sx: {
                    justifyContent: 'flex-end',
                    width: '100%',
                }, children: (0, jsx_runtime_1.jsx)(styledButtonLink_1.StyledButtonLink, { "data-testid": "forgot-password-button", onClick: () => {
                        void navigate('/signin/password/forgot');
                    }, children: lexico.trc('Form input label', 'Forgot your password?') }) }), (0, jsx_runtime_1.jsx)(LoadingBtn, { "data-testid": "login-button", color: uiConstants_1.UI_BUTTON_PRIMARY, type: "submit", loading: passwordLogin.isFormLoading, loadingPosition: "start", startIcon: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}), variant: "contained", children: strings_1.sessionStrings.CONTINUE }), globalThis.cardProvider.IS_AMEX_PROVIDER_SETUP ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(styledBox_1.StyledBox, { children: (0, jsx_runtime_1.jsx)(styledText_1.StyledText, { variant: "body1", children: lexico.trc('Form input label', 'Or use Single Sign-On (SSO)') }) }), (0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "conmtinueWithSso-btn", style: {
                            width: '100%',
                            border: `1px solid ${theme.palette.tsGoColor.pink}`,
                            color: theme.palette.tsGoColor.pink,
                            fontSize: theme.typography.pxToRem(theme.typography.tsFontSize.default),
                        }, color: uiConstants_1.UI_BUTTON_SECONDARY, label: lexico.trc('Form input label', 'Continue with SSO'), onClick: () => setLoginMethod({ isSSOLogin: true }) }), (0, jsx_runtime_1.jsxs)(material_1.Typography, { children: [lexico.trc('Support Link', 'Need Help? Contact us at: '), (0, jsx_runtime_1.jsx)(material_1.Link, { underline: "none", href: "mailto:go@tradeshift.com", target: "_blank", children: "Go@Tradeshift.com" })] })] })) : null] }, location.state?.key));
};
exports.default = PasswordLogin;
